<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M15.77,3.14a1.86,1.86,0,0,1,1.16,1.72V27.14a1.9,1.9,0,0,1-3.21,1.32l-7-6.89H1.88A1.88,1.88,0,0,1,0,19.71V12.29a1.88,1.88,0,0,1,1.88-1.86H6.75l7-6.89A1.91,1.91,0,0,1,15.77,3.14ZM21.24,11a1.91,1.91,0,0,1,2.66,0l2.43,2.4L28.77,11a1.9,1.9,0,0,1,2.68,0,1.86,1.86,0,0,1,0,2.65L29,16l2.44,2.4a1.85,1.85,0,0,1,0,2.6,1.89,1.89,0,0,1-2.63,0l-2.44-2.4L23.9,21a1.89,1.89,0,0,1-2.63,0,1.84,1.84,0,0,1,0-2.6L23.67,16l-2.43-2.4a1.85,1.85,0,0,1,0-2.63Z"
        />
</svg>
